module.exports = __webpack_public_path__ + "img/13.a1d0a2ef.jpg";